module.exports = __webpack_public_path__ + "static/3-602ddeac78afb5b3b1e307714a818c9c.jpg";